import React from "react";
import Modal from "react-modal";
import { CopyToClipboard } from "react-copy-to-clipboard";
import CheckIcon from "./CheckIcon";
import LinkIcon from "./LinkIcon";
import { useState } from "react";
import MemoShareIcon from "./ShareIcon";
import MailIcon from "./EmailIcon";

type ShareModalProps = {
  isOpen: boolean;
  closeModal: () => void;
};

const customStyles = {
  content: {
    left: "50%",
    right: "auto",
    bottom: "auto",
    backgroundColor: "white",
    maxWidth: "394px",
    maxHeight: "311px",
    height: "calc(100vh - 200px)",
    width: "calc(100vw - 40px)",
    borderRadius: "4px",
    position: "absolute",
    boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.1)",
    transform: "translate(-50%, -50%)",
    justifyContent: "space-between",
    flexDirection: "column",
    display: "flex",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
};

const ShareModal: React.FC<ShareModalProps> = ({ isOpen, closeModal }) => {
  const [copied, setCopied] = useState<boolean>(false);
  const url = window.location.href;
  const shareTitle = document.title;
  const supportsShare = navigator.share;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      style={customStyles}
      closeTimeoutMS={600}
      className="moj-modal moj-modal--small mjb"
      contentLabel="Share page"
    >
      <div className="moj-modal__content">
        <h2 className="h4">Share this page</h2>

        <div className="moj-modal__content__share">
          <input type="text" value={url} readOnly />

          <CopyToClipboard text={url} onCopy={() => setCopied(true)}>
            <button
              type="button"
              className="moj-button moj-button--secondary"
              title="Copy URL to this page"
            >
              {copied ? <CheckIcon /> : <LinkIcon />}
            </button>
          </CopyToClipboard>

          {supportsShare ? (
            <button
              type="button"
              className="moj-button moj-button--secondary"
              title="Share this page via email or social media"
              onClick={() => {
                navigator.share({
                  title: shareTitle,
                  url: url,
                });
              }}
            >
              <MemoShareIcon />
            </button>
          ) : (
            <a
              href={`mailto:?subject=${encodeURIComponent(
                shareTitle
              )}&body=${encodeURIComponent(url)}`}
              title="Share this page via email"
              className="moj-button moj-button--secondary"
            >
              <MailIcon />
            </a>
          )}
        </div>

        {copied && (
          <p className="moj-modal__content__copied">
            Link copied to the clipboard
          </p>
        )}
      </div>

      <div className="moj-modal__footer">
        <button
          type="reset"
          className="moj-modal__footer-button"
          onClick={() => {
            setCopied(false);
            closeModal();
          }}
        >
          Close
        </button>
      </div>
    </Modal>
  );
};

export default ShareModal;
